import { useSettingActions, useSettings } from "@/store/settingStore";
import { cn } from "@/utils";
import type { ReactNode } from "react";
import AccountDropdown from "../components/account-dropdown";
import BreadCrumb from "../components/bread-crumb";
import { ThemeToggle } from "@/components/common/ThemeToggle";

interface HeaderProps {
	leftSlot?: ReactNode;
}

export default function Header({ leftSlot }: HeaderProps) {
	const settings = useSettings();
	const { setSettings } = useSettingActions();
	return (
		<header
			data-slot="slash-layout-header"
			className={cn(
				"sticky z-app-bar top-0 right-0 left-auto flex items-center bg-background justify-between px-2 ml-[1px]",
				"h-[var(--layout-header-height)] grow-0 shrink-0",
			)}
		>
			<div className="flex items-center">
				{leftSlot}

				<div className="hidden md:block ml-4">{settings.breadCrumb && <BreadCrumb />}</div>
			</div>

			<div className="flex items-center gap-1">
				<ThemeToggle />
				<AccountDropdown />
			</div>
		</header>
	);
}
